// extracted by mini-css-extract-plugin
export default {"spin":"weekly-pnl-chart_spin__seBNR"};